import type { GameState } from "../domain/types";
import { escapeHtml } from "./templates";

export function profilePhotoUrl(value: unknown): string | null {
  if (typeof value !== "string" || value.length > 2048) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}

export function avatarContents(profile: Pick<GameState["profile"], "displayName" | "photoUrl">): string {
  const name = profile.displayName.trim();
  const initial = (typeof Intl.Segmenter === "function"
    ? new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(name)[Symbol.iterator]().next().value?.segment
    : Array.from(name)[0]) ?? "◇";
  const url = profilePhotoUrl(profile.photoUrl);
  return `<i class="player-avatar-initial">${escapeHtml(initial)}</i>${url === null ? "" : `<img class="player-avatar-photo" data-player-avatar src="${escapeHtml(url)}" alt="" width="76" height="76" decoding="async" referrerpolicy="no-referrer" draggable="false"/>`}`;
}
